<script setup>
import ExternalFrame from '@/components/shared/ExternalFrame.vue'
const url = 'https://crm.softway.it/?r=sso/login&t=eyJ1IjoiZGVtb0Btb3RvaG9sZGluZy5pdCIsImUiOjE3OTQyNjUxNDB9.SDN_XQfnlQ4PWOqiHmW-4CrsOYYv4D40i0viQgfz-jA'
</script>
<template>
  <external-frame
    :src="url"
    title="CRM"
  />
</template>
